import { render, staticRenderFns } from "./PrintDanhSachTinhTrangPhong.vue?vue&type=template&id=34ad48e2"
import script from "./PrintDanhSachTinhTrangPhong.vue?vue&type=script&lang=js"
export * from "./PrintDanhSachTinhTrangPhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports